module.exports = new __parcel__URL__("family-restroom.a830d4ee.svg").toString();